var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.labelClass},[(_vm.required)?_c('span',{staticStyle:{"color":"red"}},[_c('b',[_vm._v("*")])]):_vm._e(),_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }